import { render, staticRenderFns } from "./PaypalSubmitting.vue?vue&type=template&id=3c458b27&scoped=true&"
var script = {}
import style0 from "./PaypalSubmitting.vue?vue&type=style&index=0&id=3c458b27&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c458b27",
  null
  
)

export default component.exports